import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFlagCanadaGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M30.072 23.116v-3.732L26.7 22.82l.289-6.776L24 19.089l-2.602-2.651v5.892l-3.085-3.142v3.633h-3.662l5.976 6.09 1.253-.491v3.634h4.722V28.42l1.253.589 5.784-5.893h-3.567Zm-2.506 4.42-2.12-.982v4.321h-2.314v-4.223l-2.12.884-3.373-3.438h1.927v-1.866l3.085 3.143v-5.893L24 20.857l1.639-1.67-.29 6.68 3.47-3.537v2.063h1.832l-3.085 3.143Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M8 13v22h32V13H8Zm25.928 1.179v19.544H14.554V14.18h19.374Zm-24.771 0H13.3v19.544H9.157V14.18Zm29.686 19.544h-3.759V14.18h3.76v19.544Z",
    fill: "currentColor"
  }));
}

export { SvgFlagCanadaGlyph as default };
